import { FC } from "react";
import Skeleton from "react-loading-skeleton";

import PaymentMethodSignet from "web/Components/Common/PaymentMethodSignet";

import getPaymentFinancingMode from "web/utils/page/product/universal/getPaymentFinancingMode";
import getProductPointBanksEligibility from "web/utils/page/product/universal/getProductPointBanksEligibility";
import type { PaymentSettingsInput } from "web/utils/page/product/universal/parsePaymentSettings";

import { useGetBanksQuery } from "web/features/pointsBank/pointsBankApiSlice";

import classes from "./pointsStatus.scss";

interface IProductCardFooterPointsStatusProps {
  price: number;
  payments: PaymentSettingsInput;
}

const ProductCardFooterPointsStatus: FC<
  IProductCardFooterPointsStatusProps
> = ({ price, payments = [] }) => {
  const { data: dataBanks, isLoading, isError } = useGetBanksQuery();
  const { items: banks } = dataBanks || {};

  if (isLoading || isError || !dataBanks) {
    return (
      <div className={classes.root}>
        <Skeleton
          className={classes.skeleton}
          containerClassName={classes.skeletonContainer}
        />
      </div>
    );
  }

  const { availableTotal } = getProductPointBanksEligibility(banks, payments);
  const financingMode = getPaymentFinancingMode(
    price,
    availableTotal,
    payments
  );

  if (financingMode === "HIDDEN") {
    return <div />;
  }

  return (
    <div className={classes.root}>
      <PaymentMethodSignet mode={financingMode} />
    </div>
  );
};

export default ProductCardFooterPointsStatus;
